import * as _4 from 'lodash4';
import { TransferCreditsProgressState } from './../../progression/transfer_credits_progress_state';

export class ProgressTabsController {
  progressiveTabs: string[];
  selectedTab: string;
  constructor(
    private ngTransferCreditsProgressState: TransferCreditsProgressState,
    private $state: ng.ui.IStateService
  ) {
    this.progressiveTabs = this.ngTransferCreditsProgressState.ngTransferCreditsProgression.ordering as string[];
  }

  $onInit() {
    this.selectedTab = _4.find(
      this.progressiveTabs,
      (tab) => tab === _4.last(_4.get(this.$state.current, 'name', '').split('.'))
    );

    if (!this.selectedTab) {
      this.selectedTab = this.progressiveTabs[0];
    }
  }

  getStateName(tabName: string): string {
    return `my.transfer.credits.${tabName}`;
  }

  isSelectedTab(tabName: string) {
    return this.$state.includes(this.getStateName(tabName));
  }

  tabSelectionChanged($event: any) {
    if (_4.isNil($event.detail.value)) {
      return;
    }

    if (this.selectedTab !== $event.detail.value) {
      this.selectedTab = $event.detail.value;
    }
    if (_4.get(this.$state.current, 'name', '') !== this.getStateName(this.selectedTab)) {
      this.$state.go(`my.transfer.credits.${this.selectedTab}`);
    }
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngProgressTabsController', ProgressTabsController)
  .component('progressTabs', {
    controller: 'ngProgressTabsController',
    templateUrl: 'lib/transfer/components/progress_tabs/progress_tabs.html',
    controllerAs: '$ctrl'
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/progress_tabs/progress_tabs.ts